import { db } from '../firebase';
import {
  collection, addDoc, updateDoc, deleteDoc,
  doc, getDocs, query, orderBy, serverTimestamp,
} from 'firebase/firestore';
import { LegadoEvent } from '../types/Event';

const COLLECTION = 'events';

export const getEvents = async (): Promise<LegadoEvent[]> => {
  const q = query(collection(db, COLLECTION), orderBy('date', 'desc'));
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() } as LegadoEvent));
};

export const addEvent = async (event: Omit<LegadoEvent, 'id' | 'createdAt'>): Promise<string> => {
  const docRef = await addDoc(collection(db, COLLECTION), {
    ...event,
    createdAt: serverTimestamp(),
  });
  return docRef.id;
};

export const updateEvent = async (id: string, updates: Partial<LegadoEvent>): Promise<void> => {
  await updateDoc(doc(db, COLLECTION, id), updates);
};

export const deleteEvent = async (id: string): Promise<void> => {
  await deleteDoc(doc(db, COLLECTION, id));
};